import React, { useEffect, useState } from "react";
import { coverSrc } from "@/lib/coverSrc";

// WW-174 · a pasted cover link goes through the image proxy; if it will not load, show the poster missing tile.
export const PastedCoverPreview = ({ url, className, style, testid = "pasted-cover", onState }) => {
  const [state, setState] = useState("loading");
  const looksLikeLink = (u) => /^(https?:\/\/\S+\.\S+|\/)/i.test(u || "");
  const [shown, setShown] = useState(looksLikeLink(url) ? url : "");
  // wait until typing stops so half-typed links are never fetched
  useEffect(() => {
    const t = setTimeout(() => { setShown(looksLikeLink(url) ? url : ""); setState("loading"); }, 500);
    return () => clearTimeout(t);
  }, [url]);
  useEffect(() => { if (onState) onState(shown ? state : "none"); }, [state, shown, onState]);
  if (!shown) return null;
  if (state === "failed") {
    return (
      <div data-testid={`${testid}-missing`} className={`grid place-items-center rounded-md bg-amber-50 text-center text-[11px] font-semibold uppercase tracking-wider text-amber-800 ${className || ""}`} style={style}>
        poster missing · this link did not load
      </div>
    );
  }
  return (
    <img key={shown} data-testid={`${testid}-img`} data-state={state} alt="poster" src={(() => { const s = coverSrc(shown); return s.includes("/image-proxy?") ? `${s}&fresh=1` : s; })()} className={className} style={style}
         onLoad={(e) => setState(e.currentTarget.naturalWidth > 0 ? "ok" : "failed")} onError={() => setState("failed")} />
  );
};
